import { render } from "./TheMenu.vue?vue&type=template&id=32538c76&scoped=true&ts=true"
import script from "./TheMenu.vue?vue&type=script&lang=ts"
export * from "./TheMenu.vue?vue&type=script&lang=ts"

import "./TheMenu.vue?vue&type=style&index=0&id=32538c76&lang=scss&scoped=true"

import exportComponent from "/Users/keita/Develop/infonic/infpf-adminsite/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32538c76"]])

export default __exports__